import { render } from "./Col2.vue.js?vue&type=template&id=4e1562ba!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Col2.vue?vue&type=template&id=4e1562ba"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__